<html>

    <body class="dx-viewport">
       
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->  
        <dx-box
            direction="row"
            width="100%"
            [height]="formheight"
        >
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="3.0"
            >
                
                <dx-data-grid 
                    #grideventinviteetableseat
                    id="grideventinviteetableseat"

                    keyExpr="id"
                    [dataSource]="subscriptioninviteeconfirmBUTNOTablelist"    

                    [allowColumnReordering]="false"
                    [allowColumnResizing]="true"
                    [showRowLines]="true"
                    [showColumnLines]="false"
                    [showBorders]="true"
                    [repaintChangesOnly]="true"

                    [focusedRowEnabled]="true"
                    [hoverStateEnabled]="true"
                    [autoNavigateToFocusedRow]="true"

                    width="98%"
                    height="98%"

                >
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-row-dragging
                        data="subscriptioninviteeconfirmBUTNOTablelist"
                       
                        group="tasks"

                        [showDragIcons]="true"
                        [allowDropInsideItem]="true"

                        [onAdd]="onAdd"
                        [onDragStart]="onDragStartInviteeName"

                        dragTemplate="myDragTemplate"
                    >
                    
                        <div *dxTemplate="let e of 'myDragTemplate'">
                            {{ e.itemData.firstname}}&nbsp;{{ e.itemData.lastname}}
                        </div>        
                    
                    </dxo-row-dragging>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                     <dxo-filter-row
                        [visible]="true"
                    ></dxo-filter-row>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxo-sorting
                        mode="single"> <!-- or "multiple" | "none" -->
                    </dxo-sorting>

                    <dxo-selection
                        mode="single"
                    >
                    </dxo-selection>

                    <dxo-load-panel
                        [enabled]="false">
                    </dxo-load-panel>

                    <dxo-editing 
                        mode="cell"                            
                        [allowUpdating]="false"
                        [allowDeleting]="false"
                        [allowAdding]="false"
                        [useIcons]="false"
                    >
                    </dxo-editing>
                    <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
                    <dxi-column
                        dataField="id"
                        caption="id"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="false"
                        width="19%"
                    >

                    </dxi-column>   

                    <dxi-column
                        dataField="whoseparticipant"
                        caption="Whose Guest"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [allowFiltering]="false"
                        [visible]="true"
                        width="19%"

                        groupCellTemplate="cellparticipantname"
                        [groupIndex]="0"
                    >

                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->    
                        <div *dxTemplate="let d of 'cellparticipantname'">
                            <div>{{whoseguest | getinitial: d.value: whoseguest.length: 10 }}</div> 
                        </div>  
                        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx--> 

                    </dxi-column>   

                    <dxi-column
                        dataField="title"
                        caption="Title"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >

                    </dxi-column>   

                    <dxi-column
                        dataField="lastname"
                        caption="Last Name"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >
                    </dxi-column>

                    <dxi-column
                        dataField="firstname"
                        caption="First Name"
                        [allowEditing]="false" 
                        [allowSorting]="false"
                        [visible]="true"
                        width="19%"
                    >
                    </dxi-column>

                </dx-data-grid>

            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="0.005"
            >
            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
            <dxi-item
                [ratio]="7.0"
            >
                <!----------------------------------------------------------------------------------------------->
                <div>
                    <dx-button
                        text="Add Table"
                        stylingMode="contained"
                    
                        type="normal"
                        width="100%"

                        (onClick)="onClickNewTable($event)"
                    >
                    </dx-button>
                </div>
                <!----------------------------------------------------------------------------------------------->
                <dx-scroll-view
                    #scrollView
                    id="scrollview"

                    width="100%"
                    height="98%"

                    direction="both" 
                    [scrollByContent]="true"

                    showScrollbar="always"
                    [useNative]="false"
                    reachBottomText="Updating..."
                >

                    <!----------------------------------------------------------------------------------------------->
                    <dx-tile-view
                        id="invitetable"
                        #invitetable
                        [dataSource]="subscriptioninviteetableseatnolist"

                        [baseItemHeight]="300"
                        [baseItemWidth]="160"

                        width="100%"
                        height="100%"

                        [hoverStateEnabled] = "true"

                        [itemMargin]="15" 

                        direction="vertical"

                        itemTemplate="list-item"

                        (onItemClick)="tileselect($event)"

                    >
                        <div *dxTemplate="let data of 'list-item'; let index = index;">
                            <!----------------------------------------------------------------------------------------------->
                            <dx-box
                                direction="col"
                                width="100%"
                                height="100%"
                            >
                                <!----------------------------------------------------------------------------------------------->
                                <dxi-item
                                    [ratio]="1.0"
                                    class="rectanglecard1"
                                >
                                    <img [src]="" [id]="'tileview' + data.id" />
                                   
                                    <div class="navigation" >

                                        <div>
                                            <dx-button 
                                                id="tileViewButton"
                                               
                                                stylingMode="contained"
                                                type="normal"

                                                text={{data.table}}  
                                                [hint]="tablehint"

                                                (onClick)="onTableAssignClicked(data)"
                                                (mouseover)="btnmouseover(data)"

                                                width="110"
                                                height="80%"
                        
                                               
                                            >
                                            </dx-button>
                                        </div>

                                        <div>
                                            [ {{data.tableorder}} ]
                                        </div>

                                    </div>
                                       
                                </dxi-item>
                                <!----------------------------------------------------------------------------------------------->
                                <dxi-item
                                    [ratio]="9"
                                    class="rectanglecard1"
                                >
                                    <!----------------------------------------------------------------------------------------------->
                                    <dx-list
                                        #tablelist
                                        id="tablelist"

                                        [items]="data.inviteename"

                                        height="98%"

                                        [allowItemDeleting]="true"
                                        itemDeleteMode="toggle"
                                        (onItemDeleted)="inviteeonItemDeleted($event, data.inviteename)"

                                    >
                                        <!----------------------------------------------------------------------------------------------->
                                        <dxo-item-dragging
                                            group="tasks"

                                            [data]="data.inviteename"

                                            [allowReordering]="true"
                                            [onReorder]="onReorder"

                                            [onDragStart]=  "onDragStart"

                                            [onAdd]="onAdd"
                                            [onRemove]="onRemove"

                                            dragTemplate="myDragTemplate1"
                                        >

                                            <div *dxTemplate="let e of 'myDragTemplate1'">
                                                {{dragitem_inviteename}}
                                            </div> 

                                        </dxo-item-dragging>
                                        <!----------------------------------------------------------------------------------------------->
                                        <div *dxTemplate="let item of 'item'">
                                            <div>{{item | extractinviteename:5 }}</div> 
                                        </div>
                                        <!----------------------------------------------------------------------------------------------->
                                    </dx-list>
                                    <!----------------------------------------------------------------------------------------------->
                    
                                </dxi-item>

                            </dx-box>

                        </div>  

                    </dx-tile-view>
                    <!----------------------------------------------------------------------------------------------->

                </dx-scroll-view>
                <!----------------------------------------------------------------------------------------------->
            </dxi-item>
            <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        </dx-box>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            [width]="300"
            [height]="200"
            [showTitle]="true"
            title="Set Table Name & Order"
            [dragEnabled]="true"
            [hideOnOutsideClick]="false"
            [showCloseButton]="false"
           
            [(visible)]="popupVisible"
        >
            <!------------------------------------------------------------------------->
            <dxo-position

                my="left top" 
                    
                [of]="positionOf"

            >
            </dxo-position>
            <!------------------------------------------------------------------------->
            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Save',
                                type: 'success',
                                onClick: saveTableNameClick
                            }"

            >
            </dxi-toolbar-item>

            <dxi-toolbar-item
                widget="dxButton"
                location="after"
                toolbar="bottom"

                [options]="{
                                text: 'Cancel',
                                onClick: cancelTableNameClick
                            }"

            >
            </dxi-toolbar-item>
             <!------------------------------------------------------------------------->
             <dx-text-box
                [(value)]="seltablename"
                label="Table Name"
                id="tablename"

                height="30px"
                placeholder="Enter Table Name"
                stylingMode="outlined"
                labelMode="floating"
            >
                <dx-validator>
                    <dxi-validation-rule 
                        type="required"
                        message="Table Name cannot be blanked"
                    > 
                    </dxi-validation-rule>
                   
                </dx-validator>

             
            </dx-text-box>
            <!------------------------------------------------------------------------->
            <br>
             <!------------------------------------------------------------------------->
             <dx-number-box
                [(value)]="seltableorder"
                label="Table Order"
                id="tableorder"

                height="30px"
                placeholder="Enter Table Order"
                stylingMode="outlined"
                labelMode="floating"
            >
                <dx-validator>
                    <dxi-validation-rule 
                        type="required"
                        message="Table Order cannot be blanked"
                    > 
                </dxi-validation-rule>
                    
                </dx-validator>

          
            </dx-number-box>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
    </body>

</html>
